<template>
  <div class="h-screen">
    <iframe class="rounded h-full w-full h-dashboard-pcp" :src="dashboardUrl" frameborder="0">
    </iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';


import { differenceInSeconds, parseISO } from 'date-fns';

export default {
  name: 'PcpContent',
  data() {
    return {
      dashboardUrl: null,
    };
  },
  computed: {
    ...mapGetters('environment', [
      'getSelectedBatch',
      'getDashboardsSettings',
    ]),
    baseUrl: {
      get() {
        return (
          process.env.VUE_APP_GRAFANA_URL +
          `d/${this.getDashboardsSettings['pcp_projection'][this.$i18n.locale]}?orgId=1`
        );
      },
    },
  },
  watch: {
    getSelectedBatch: {
      immediate: true,
      handler(batch) {
        if (!batch) {
          this.dashboardUrl = null;
          return;
        }
        this.$emit('set-loading', true);

        const url = new URL(this.baseUrl);

        let openingDate = differenceInSeconds(new Date(), parseISO(batch.openingDate)) + 60;
        let closingDate = differenceInSeconds(new Date(), parseISO(batch.closingDate)) + 60;

        url.searchParams.append('theme', "light");
        url.searchParams.append('var-batch_id', batch.id);
        url.searchParams.append('var-age', batch.age - 1);

        url.searchParams.append('from', openingDate > 0 ? `now-${openingDate}s` : 'now-24h');
        url.searchParams.append('to', closingDate > 0 ? `now-${closingDate}s` : `now+${(50 - batch.age) * 24 * 60 * 60}s`);

        this.dashboardUrl = url.toString() + '&kiosk';

        this.$emit('set-loading', false);
      },
    },
  },
};
</script>

<style>
.h-dashboard-pcp {
  height: 828px !important;
}

@media(max-width: 888px) {
  .h-dashboard-pcp {
    height: 1492px !important;
  }
}
</style>
